import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulseIcon, MessageSquareIcon, ClipboardListIcon, UserCheckIcon } from 'lucide-react';
export function HealthConsulting() {
  const services = [{
    title: 'Medication Therapy Management',
    desc: 'Comprehensive review of all your medications to ensure they are working effectively together.'
  }, {
    title: 'Chronic Disease Support',
    desc: 'Specialized guidance for managing conditions like diabetes, hypertension, and asthma.'
  }, {
    title: 'Wellness Planning',
    desc: 'Personalized nutrition and lifestyle recommendations tailored to your specific health goals.'
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white min-h-screen pb-20" data-id="element-406">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20 mb-12 md:mb-16" data-id="element-407">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-clinical-blue/5 text-clinical-blue rounded-full text-[10px] font-bold uppercase tracking-widest mb-6" data-id="element-408">
          Clinical Services
        </div>
        <h1 className="text-3xl md:text-5xl font-black text-slate-900 mb-6 uppercase tracking-tighter" data-id="element-409">
          Health Consulting
        </h1>
        <p className="text-lg md:text-xl text-slate-600 max-w-3xl leading-relaxed" data-id="element-410">
          Expert clinical advice tailored to you. Our pharmacists offer
          one-on-one consultations to help you achieve your health and wellness
          objectives.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-411">
        <div className="grid lg:grid-cols-3 gap-8" data-id="element-412">
          {services.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.1
        }} className="bg-clean-grey p-8 rounded-2xl border border-slate-100 flex flex-col h-full" data-id="element-413">
              <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center text-clinical-blue mb-6" data-id="element-414">
                {i === 0 ? <ClipboardListIcon className="w-6 h-6" data-id="element-415" /> : i === 1 ? <HeartPulseIcon className="w-6 h-6" data-id="element-416" /> : <UserCheckIcon className="w-6 h-6" data-id="element-417" />}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-418">
                {s.title}
              </h3>
              <p className="text-slate-600 leading-relaxed flex-grow" data-id="element-419">
                {s.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-20 bg-slate-900 rounded-3xl overflow-hidden flex flex-col md:flex-row" data-id="element-420">
          <div className="p-8 md:p-16 md:w-1/2 text-white" data-id="element-421">
            <MessageSquareIcon className="w-12 h-12 mb-8 text-clinical-blue" data-id="element-422" />
            <h2 className="text-3xl font-black mb-6 uppercase tracking-tight" data-id="element-423">
              Speak with a Clinical Pharmacist
            </h2>
            <p className="text-slate-400 mb-10 leading-relaxed text-lg" data-id="element-424">
              Our private consultation rooms provide a comfortable space to
              discuss your health concerns and medication needs in complete
              confidence.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-425">
              <button className="bg-clinical-blue text-white font-black py-4 px-8 rounded-xl hover:bg-blue-700 transition-colors uppercase tracking-widest text-xs" data-id="element-426">
                Request Consultation
              </button>
              <button className="border-2 border-slate-700 text-white font-black py-4 px-8 rounded-xl hover:bg-slate-800 transition-colors uppercase tracking-widest text-xs" data-id="element-427">
                Learn More
              </button>
            </div>
          </div>
          <div className="md:w-1/2 bg-slate-800 min-h-[300px] relative" data-id="element-428">
            <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=1200&auto=format&fit=crop" alt="Pharmacist Consultation" className="absolute inset-0 w-full h-full object-cover opacity-60" data-id="element-429" />
          </div>
        </div>
      </div>
    </motion.div>;
}